module.exports = __webpack_public_path__ + "img/96.a87516f0.png";